<template>
    <div class="portfolioItemList">
      <!--<div v-if="getActiveCategory !== undefined && getActiveCategory.length > 0">
      </div>-->
      <div class="portfolioItemListWrap">
        <portfolio-item
          v-if="activeCategory != null"
          :portfolios="VIEW__PORTFOLIO"
        />
      </div>
      <paginate
        v-if="activeCategory != null && activeCategory.length > 0
        && VIEW__PORTFOLIO != null && VIEW__PORTFOLIO.length > 0"
        :page-count="parseInt(pagination.endPage)"
        :click-handler="handlePaging"
        :prev-text="'이전'"
        :next-text="'다음'"
        :container-class="'pagination'"
        :page-class="'page-item'"
        :prev-link-class="'page-prev'"
        :next-link-class="'page-next'"
        ref="paginate"
      >
      </paginate>
    </div>
</template>

<script>
    import PortfolioItem from "./PortfolioItem";
    import Paginate from 'vuejs-paginate'

    import {mapState , mapGetters } from 'vuex'

    export default {
      components: {
        PortfolioItem ,
        Paginate
      },
      name: "portfolio-item-list" ,
      computed : {
        ...mapState('portfolioStore' , ['pagination']) ,
        ...mapGetters(
          {
            portfolios : 'portfolioStore/getPortfolios' ,
            activeCategory : 'categoryStore/getActiveCategory' ,
            allCategoryNum : 'categoryStore/getCategoryByAll' ,
            _portfolios : 'portfolioStore/getPortfoliosByFilter' ,
            VIEW__PORTFOLIO : 'portfolioStore/GET__VIEW__PORTFOLIO' ,
          }
        ),
        portfoliosFilter () {
          //console.log();
          const activeCategories = this.$store.state.categoryStore.activeCategory;

          if(activeCategories != null &&
            activeCategories.length === 1 &&
            activeCategories[0] === this.allCategoryNum){
            return this.portfolios;
          }
          else{
            return this.$store.state.portfolioStore.portfolios.filter( n => { //포트폴리오 카테고리 필터링
                  let result = false;
                  for(let i = 0 ; i < n.categories.length; i++){
                    result = result || activeCategories.includes(n.categories[i]);
                    if(result)
                      break;
                  }
                  return result;
            })
          }
        },
      },
      watch : {
        portfolios () { //페이징 초기화
          const len = this.portfolios.length;
          const perPage = this.pagination.perPage;
          //console.log('perPage' , this.pagination.perPage)

          this.$store.commit('portfolioStore/setPage' , {
            currentPage : 1 ,
            startPage : 1 ,
            endPage : Math.ceil(len / perPage) ,
          })
        },
        portfoliosFilter () {
          this.$store.commit('portfolioStore/setPortfolioFilter' , {
            portfolios : this.portfoliosFilter
          })
          this.setViewPortfolio(1 , false);
        },
        VIEW__PORTFOLIO () {
          //console.log('VIEW__PORTFOLIO!!!');
        }
      },
      created () {

        this.$store.dispatch('portfolioStore/getPortfolios')
          .then( () => {
            this.$store.commit('portfolioStore/setPortfolioFilter' , {
              portfolios : this.portfoliosFilter
            });

            if(this.portfoliosFilter != null && this.portfoliosFilter.length > 0)
              this.setViewPortfolio(1 , false);
          })
      },
      data () {
        return {
          _portfoliosFilter : null
        }
      },
      methods : {
        handlePaging (page) {
          //console.log(page);
          this.setViewPortfolio(page , true)

        },
        setViewPortfolio (page , handle) {
          if(page !== undefined){

            const len = this.portfoliosFilter.length;
            const perPage = this.pagination.perPage;
            const startIndex = (page - 1) * perPage;
            const endIndex = startIndex + (perPage - 1);



            //console.log(startIndex , endIndex);

            //console.log(limit , offset);
            this.$store.commit('portfolioStore/SET__VIEW__PORTFOLIO' , {
              portfolios : this.portfoliosFilter.filter( ( v , i ) => {
                return i >= startIndex && i <= endIndex;
              }) ,
            })

            this.$store.commit('portfolioStore/setPage' , {
              currentPage : page ,
              endPage : Math.ceil(len / perPage)
            });

            if( !(handle !== undefined && handle) ){
              if(this.$refs.paginate !== undefined)
                this.$refs.paginate.selected = 0;
            }
            else{

              //
            }

          }
        }
      }
    }
</script>

<style lang="scss">
  .portfolioItemListWrap{
    /*display: grid;
    grid-template-columns: calc(100%/3) calc(100%/3) calc(100%/3);
    grid-template-rows: auto auto;*/
    margin-bottom:2rem;
  }
  .pagination {
    display: flex;
    justify-content: center;
    list-style: none;
    margin-bottom:1rem;
    li{
      width:40px;
      height:30px;
      border:1px solid #ddd;
      color: #0275d8;
      background: #fff;
      text-decoration: none;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 2px;
      &:hover {
        background: #ddd;
      }
      &.page-item {
        width:30px;
        //height:30px;
      }
      &.page-item.active {
        background:#0275d8;
        border-color:#0275d8;
        color:#fff;
        cursor:default;
      }
      a {
        width:100%;
        height:100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      a:focus {
        outline: none;
      }
      a.page-prev , a.page-next {
        //color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/Portfolio/PortfolioItemList.vue